/* eslint-disable no-alert, no-console */
<template>
  <div class="user-issues">
    <div class="user-issues__tickets">
      <div class="user-issues__tickets-wrapper">
        <h1 class="user-issues__tickets-title">Обращения в поддержку</h1>
        <router-link
        to="/support"
        class="user-issues__tickets-create__link"
      >
        <Button label="+ Создать" class="p-button-outlined p-button-sm" />
      </router-link>
      </div>
      
      <div>
        <div v-if="isLoadingOffers">
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 15px"
            height="110px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 15px"
            height="110px"
          />
          <Skeleton
            class="order-cards__skeleton"
            width="100%"
            style="margintop: 15px"
            height="110px"
          />
        </div>
        <div
          v-else-if="this.tickets.length == 0"
          class="user-issues__nooffers"
        >
          <p>У вас нет обращений в поддержку</p>
        </div>
        <div v-else>
          <div class="user-issues__search-wrapper">
          <span class="user-issues__search__form-search p-input-icon-left">
            <i class="pi pi-search" />
            <InputText type="text" v-model="inputValue" placeholder="Поиск" />
          </span>
          </div>
          <div
            v-for="(ticket, index) in this.searchedTickets"
            :key="index"
            class="user-issues__refund-item"
          >
          <router-link
            :to="{
              name: 'SupportTicket',
              params: {
                ticketId: ticket.id,
              },
            }"
            class="ticket-num__btn-options__change-link"
          >
            <div>
              <div class="user-issues__refund-item__subject">
                <img
                  :src="require(`../assets/images/support-subject.svg`)"
                  alt=""
                  class="user-issues__refund-item__icon"
                  title="Тема заявки"
                />
                <p>{{ "#"+ticket.id + " " + ticket.subject }}</p>
              </div>
              <div class="user-issues__refund-item__date">
                <img
                  :src="require(`../assets/images/calendar.svg`)"
                  alt=""
                  class="user-issues__refund-item__icon"
                />
                <p>{{ getCreatedDate(ticket.created_on) }}</p>
              </div>
              <div
                v-if="
                  ticket.status.id == 1 ||
                  ticket.status.id == 2
                "
                class="user-issues__refund-item__status"
              >
                <div class="user-issues__refund-item__status-icon">
                  <svg
                    width="10"
                    height="10"
                    viewBox="0 0 10 10"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#F37E21" />
                  </svg>
                </div>
                <p>{{ ticket.status.name }}</p>
              </div>
              <div
                v-if="ticket.status.id == 3 || ticket.status.id == 4 || ticket.status.id == 5"
                class="user-issues__refund-item__status"
              >
                <div class="user-issues__refund-item__status-icon">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#6BC242" />
                  </svg>
                </div>
                <p>{{ ticket.status.name }}</p>
              </div>
              <div
                v-if="ticket.status.id == 6"
                class="user-issues__refund-item__status"
              >
                <div class="user-issues__refund-item__status-icon">
                  <svg
                    width="8"
                    height="8"
                    viewBox="0 0 8 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <ellipse cx="4" cy="3.5" rx="4" ry="3.5" fill="#e90b0b" />
                  </svg>
                </div>
                <p>{{ ticket.status.name }}</p>
              </div>
            </div>
          </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, watchEffect, defineComponent } from "vue";
import axios from "axios";
import { useRouter, useRoute } from "vue-router";
import store from "../store";
import Skeleton from "primevue/skeleton";
import InputText from "primevue/inputtext";
import Button from "primevue/button";

const axioCred = axios.create({
  withCredentials: true,
});

export default defineComponent({
  name: "UserOffers",
  components: {
    Skeleton,
    InputText,
    Button
  },
  props: [],
  setup(props) {
    const isLoadingOffers = ref(false);
    const error = ref(null);
    let tickets = ref(store.state.tickets);
    let searchedTickets = ref(store.state.tickets);
    const router = useRouter();
    const route = useRoute();
    let inputValue = ref("");
    const getUserIssues = async () => {
      isLoadingOffers.value = true;
      try {
        const json = await axioCred.get(
          `https://www.biletdv.ru/customer/IBEServices/GetUserIssuesForBackOffice`
        );
        if (json.data) {
          let fetchedOrders = await json.data;

          tickets.value = fetchedOrders.supportRequests.issues;
          searchedTickets.value = fetchedOrders.supportRequests.issues;
          isLoadingOffers.value = false;
        } else {
          console.log("error!");
          isLoadingOffers.value = false;
        }

        isLoadingOffers.value = false;
        console.log(tickets.value);
      } catch (err) {
        if (err.response.status == 401) {
          store.dispatch("auth/logout");
          router.push("/login");
        }
      }
    };
    watch(
      [inputValue, tickets],
      (newValue: any, oldValue: any) => {
        let value: string = inputValue.value;
          if (value) {
            searchedTickets.value = tickets.value.filter(function (issue: any) {              
              return (
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) =>
                    issue.subject.toLowerCase().includes(v)
                  ) ||
                value
                  .toLowerCase()
                  .split(" ")
                  .every((v: any) => issue.id.toString().includes(v))
              
              )})
              console.log(searchedTickets.value);
              
      }
      else if(!inputValue.value){
        searchedTickets.value = tickets.value;
        
      }
      })
    return {
      getUserIssues,
      isLoadingOffers,
      error,
      tickets,
      inputValue,
      searchedTickets

    };
  },
  data() {
    return {
      month: [
        "янв",
        "фев",
        "мар",
        "апр",
        "мая",
        "июн",
        "июл",
        "авг",
        "сен",
        "окт",
        "ноя",
        "дек",
      ],
    };
  },
  methods: {
    
    getCreatedDate(date: any) {
      let created: any = new Date(date);
      let createdDay = created.getDate();
      let createdMonth: any = created.getMonth();
      let createdYear = created.getFullYear();
      let createdHours = function () {
        if (created.getHours() < 10) {
          return "0" + created.getHours();
        } else {
          return created.getHours();
        }
      };
      let createdMinutes = function () {
        if (created.getMinutes() < 10) {
          return "0" + created.getMinutes();
        } else {
          return created.getMinutes();
        }
      };
      return (
        createdDay +
        " " +
        this.month[createdMonth] +
        " " +
        createdYear +
        " " +
        createdHours() +
        ":" +
        createdMinutes()
      );
    },
    getOfferStatus(num: number) {
      if (num == 10) {
        return "Заявка создана";
      } else if (num == 20) {
        return "Заявка в работе";
      } else if (num == 30) {
        return "Заявка обработана";
      } else if (num == 40) {
        return "Сообщение";
      }
    },
    getTicketStatus(num: number) {
      if (num == 1) {
        return "Заявка создана";
      } else if (num == 2) {
        return "Заявка в работе";
      } else if (num == 3) {
        return "Заявка успешно решена";
      } else if (num == 4) {
        return "Требуется обратная связь";
      } else if (num == 5) {
        return "Заявка закрыта";
      } else if (num == 6) {
        return "Отказ по заявке";
      }
    },
  },
  created() {
    this.getUserIssues();
  },
});
</script>

<style>
.user-issues__refund-item {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 10px;
  margin-top: 15px;
}

.user-issues__tickets-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-issues__search-wrapper {
  margin-top: 20px;
}

.user-issues__search-wrapper .p-input-icon-left {
  display: block;
}

.user-issues__tickets-title {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  margin: 0 0 0 20px;
}

.user-issues__tickets-create__link {
  text-decoration: none;
}

.user-issues__nooffers {
  background-color: #fff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 3px;
  overflow: hidden;
  padding: 30px 10px 30px 20px;
  margin-top: 15px;
}

.user-issues__refund-item__number {
  display: flex;
  align-items: center;
}

.user-issues__refund-item__icon {
  width: 23px;
  height: 25px;
  margin-right: 10px;
}

.user-issues__refund-item__date {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.user-issues__refund-item__status {
  display: flex;
  margin-top: 10px;
}

.user-issues__refund-item__subject {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.user-issues__refund-item__status-icon {
  width: 23px;
  height: 25px;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-right: 10px;
}

</style>
